import { Injectable, PLATFORM_ID, signal, DOCUMENT, inject, effect } from '@angular/core';
import { THEME_CONFIG } from '../../environments/tokens/theme.token';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ThemeService {
  private themeConfig = inject(THEME_CONFIG)
  private platformId = inject(PLATFORM_ID)
  private breakpointObserver = inject(BreakpointObserver)
  private document = inject(DOCUMENT)

  readonly darkModeObserver$ = this.breakpointObserver
    .observe(['(prefers-color-scheme: dark)', '(prefers-color-scheme: light)'])
    .pipe(map(result => result.breakpoints['(prefers-color-scheme: dark)']))

  darkMode = signal<boolean>(false);

  constructor() {
    const strategy = this.themeConfig.modeResolutionStrategy;
    if (strategy === 'disabled') {
      this.darkMode.set(this.themeConfig.mode === 'dark')
    } else if (strategy === 'implicit') {
      this.darkModeObserver$.subscribe(isDark => this.darkMode.set(isDark))
    } else {
      throw Error('Explict dark mode strategy selected. This feature is not supported at the moment')
    }

    effect(() => {
      if (this.darkMode()) {
        this.document.body.classList.add('dark')
      } else {
        this.document.body.classList.remove('dark')
      }
    })
  }
}
